import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const CMSLogisticsSettingsComponent = ({ selectCMSSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Assistance"
                            name="Assistance"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.Assistance',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.Assistance}
                        />
                        <InputContainer
                            label="PickUp And Drop"
                            name="PickUpAndDrop"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.PickUpAndDrop',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.PickUpAndDrop}
                        />
                        <InputContainer
                            label="Packers And Movers"
                            name="PackersAndMovers"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.PackersAndMovers',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.PackersAndMovers}
                        />
                        <InputContainer
                            label="Overseas Delivery"
                            name="OverseasDelivery"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.OverseasDelivery',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.OverseasDelivery}
                        />
                        <InputContainer
                            label="Enable For Enterprise"
                            name="ForEnterprise"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.ForEnterprise',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.ForEnterprise}
                        />
                        <InputContainer
                            label="Enable For Partner"
                            name="EnableForPartner"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.EnableForPartner',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.EnableForPartner}
                        />
                        <InputContainer
                            label="Enable For Vendor"
                            name="EnableForVendor"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.EnableForVendor',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.EnableForVendor}
                        />
                        <InputContainer
                            label="Cargo"
                            name="Cargo"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsSettings.Cargo',
                                    selectCMSSettings?.LogisticsSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.LogisticsSettings?.Cargo}
                        />
                    </div>
                }
                expandedPanel="Logistics Settings"
                headerTitle="Logistics Settings"
            />
        </>
    )
}
export default CMSLogisticsSettingsComponent;
